<div class="search-options flex flex-row flex-wrap gap-[25px] justify-start items-baseline">
  <mat-form-field
    mat-input-height-large-label
    class="flex-[48%] max-w-[48%] xs:flex-[100%] xs:max-w-[100%]"
  >
    <mat-label>{{
      '+SEARCH.SEARCH_BY_GATEWAY.PLACEHOLDER.COMMUNICATION_MODULE' | translate
    }}</mat-label>
    <input
      data-at-gateway-serial
      matInput
      name="gatewaySerial"
      [(ngModel)]="gatewaySerial"
      (keyup.enter)="search()"
      gtm="onEditTextField"
      gtmAction="Gateway serial"
      gtmCategory="search"
      [gtmOn]="['change', 'focus', 'blur']"
    />
    <mat-error *ngIf="gatewaySerialValidationErrorPresent">{{
      '+SEARCH.SEARCH_BY_GATEWAY.COMMUNICATION_MODULE.VALIDATION_MESSAGE' | translate
    }}</mat-error>
    <button
      data-at-close-btn
      *ngIf="gatewaySerial"
      matSuffix
      mat-icon-button
      aria-label="Clear"
      gtm="onClearSearch"
      gtmAction="Gateway serial search query"
      gtmCategory="search"
      gtmLabel="clearGatewaySerial"
      (click)="gatewaySerial = ''"
    >
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
  <mat-form-field
    mat-input-height-large-label
    class="flex-[48%] max-w-[48%] xs:flex-[100%] xs:max-w-[100%]"
  >
    <mat-label>{{
      '+SEARCH.SEARCH_BY_GATEWAY.OPTION_SEARCH.PLACEHOLDER.SERIAL_NUMBER' | translate
    }}</mat-label>
    <input
      data-at-boiler-serial
      matInput
      name="boilerSerial"
      [(ngModel)]="boilerSerial"
      (keyup.enter)="search()"
      gtm="onEditTextField"
      gtmAction="Boiler serial"
      gtmCategory="search"
      [gtmOn]="['change', 'focus', 'blur']"
    />
    <mat-error *ngIf="boilerSerialValidationErrorPresent">{{
      '+SEARCH.SEARCH_BY_GATEWAY.SERIAL_NUMBER.VALIDATION_MESSAGE' | translate
    }}</mat-error>
    <button
      data-at-close-btn
      *ngIf="boilerSerial"
      matSuffix
      mat-icon-button
      aria-label="Clear"
      gtm="onClearSearch"
      gtmAction="Boiler serial search query"
      gtmCategory="search"
      gtmLabel="clearBoilerSerial"
      (click)="boilerSerial = ''"
    >
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
</div>
<div class="button-wrapper flex flex-row justify-end items-center">
  <button
    mat-stroked-button
    color="primary"
    gtm="onClearSearch"
    gtmAction="Gateway search query"
    gtmCategory="search"
    (click)="clear()"
  >
    {{ 'GENERAL.BUTTON.CLEAR' | translate }}
  </button>
  <button
    disabled
    mat-raised-button
    color="primary"
    gtm="onSearch"
    gtmAction="Gateway"
    gtmCategory="search"
    (click)="search()"
    [class.disabled]="isSearchDisabled()"
    [disabled]="isSearchDisabled()"
  >
    {{ 'GENERAL.BUTTON.SEARCH' | translate }}
  </button>
</div>
